export const localStorageLocale = 'locale'

// Because i18next does not keep the locales in its own state, we also export
// this function to get the locales in the Language selector
export const locales = (): string[] => ['nl-NL', 'en-NL']
